/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Div, Group, Link, Panel, Spacing
} from '@vkontakte/vkui';
import { useUnit } from 'effector-react';
import { memo, useCallback } from 'react';
import { AppPanels, AppPanelsT } from 'src/app/providers/RouteProvider/lib/routeConfig';
import { setActivePanel } from 'src/entity/ActivePanel';
import mainLogo from 'src/shared/assets/images/2024/head.png';
import textLogo from 'src/shared/assets/images/2024/txt.png';
import { CharactersCover } from 'src/shared/ui/charactersCover/CharactersCover';
import { Cover } from 'src/shared/ui/cover';
import { SuperBtn } from 'src/shared/ui/superBtn';
import bridge from '@vkontakte/vk-bridge';
import styles from './styles.module.scss';

interface IIntroPanelProps {
  id: AppPanelsT;
}

export const IntroPanel = memo(({ id }: IIntroPanelProps) => {
  // @ts-ignore
  bridge.send('VKWebAppSendCustomEvent', {
    event: 'launch',
    screen: 'intro'
  });

  const [
    onSetActivePanel
  ] = useUnit([
    setActivePanel
  ]);

  const onRulesButtonClick = useCallback(() => {
    onSetActivePanel(AppPanels.RULES);
  }, [onSetActivePanel]);

  const onStartButtonClick = useCallback(() => {
    onSetActivePanel(AppPanels.SECOND_STAGE_NOMINATIONS);
    // @ts-ignore
    bridge.send('VKWebAppSendCustomEvent', {
      event: 'vote_click',
      screen: 'intro'
    });
  }, [onSetActivePanel]);

  const onPlayButtonClick = useCallback(() => {
    onSetActivePanel(AppPanels.PUZZLE_GAME);
    // @ts-ignore
    bridge.send('VKWebAppSendCustomEvent', {
      event: 'play_click',
      screen: 'intro'
    });
  }, [onSetActivePanel]);

  const onSetStatusButtonClick = useCallback(() => {
    onSetActivePanel(AppPanels.FINAL);
    // @ts-ignore
    bridge.send('VKWebAppSendCustomEvent', {
      event: 'set_emoji_status_click',
      screen: 'intro'
    });
  }, [onSetActivePanel]);

  return (
    <Panel id={id}>
      <Group>
        <Div className={styles.main_heroes_logo}>
          <img src={mainLogo} alt='Главные Герои 2024' />
        </Div>

        <Div className={styles.textLogo}>
          <img src={textLogo} alt='text' />
        </Div>
        <Spacing size={18} />

        <Div className={styles.info}>
          <Spacing size={18} />
          <SuperBtn
            size='l'
            onClick={onStartButtonClick}
            text='Голосовать'
            color='2'
          />
          <Spacing size={36} />

          <SuperBtn
            size='s'
            text='Играть'
            color='3'
            onClick={onPlayButtonClick}
          />

          {/* <Spacing size={18} />
          <SuperBtn
            size='s'
            text='Установить эмодзи-статус'
            color='1'
            onClick={onSetStatusButtonClick}
          /> */}

          <Spacing size={18} />
          <Link onClick={onRulesButtonClick} className={styles.link}>
            Правила проведения Национальной детской премии
            <br />
            «Главные Герои 2024»
          </Link>

        </Div>
      </Group>
      <Cover />
      <CharactersCover />
    </Panel>
  );
});
